module.exports = __webpack_public_path__ + "img/KinokoTable73.f7df11e3.jpg";